/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { WearablesStrictHttpResponse } from '../../wearables-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkoutModel } from '../../models/workout-model';

export interface ProfileWorkoutHistoryGet$Params {
}

export function profileWorkoutHistoryGet(http: HttpClient, rootUrl: string, params?: ProfileWorkoutHistoryGet$Params, context?: HttpContext): Observable<WearablesStrictHttpResponse<Array<WorkoutModel>>> {
  const rb = new RequestBuilder(rootUrl, profileWorkoutHistoryGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as WearablesStrictHttpResponse<Array<WorkoutModel>>;
    })
  );
}

profileWorkoutHistoryGet.PATH = '/Profile/WorkoutHistory';
